import { useAppStore } from '@/store/app.store';

import { AssetDetailsMode } from '../asset-details-mode/asset-details-mode.component';
import { Fulfillment } from '../fulfillment/fulfillment.component';
import { Organize } from '../organize/organize.component';

import styles from './styles.module.scss';

export const AssetDetailsContent = () => {
    const activeAssetDetailsView = useAppStore((state) => state.assetDetails.view);

    return (
        <div className={styles.asset_details_content}>
            <AssetDetailsMode />
            {activeAssetDetailsView === 'fulfill' ? <Fulfillment /> : <Organize />}
        </div>
    );
};
